import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initAuth } from './auth/msal';
import './formio-setup';
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found.');
}

// Initialise MSAL (and process any sign-in redirect) before first render.
void initAuth().finally(() => {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
